import jQuery from 'jquery';
import Translator from './translate-service';
//import jGrowl from 'jgrowl';

var validationMessagingInitialised = false;

export function initialiseMessaging(){
    if ( !validationMessagingInitialised ){
        $.jGrowl.defaults.position = "center";
        $.jGrowl.defaults.closer = false;
        validationMessagingInitialised = true;
    }
}

export function showErrorMessage(message, sticky){
    
    if (typeof sticky === "undefined" || sticky === null){
        sticky = true;
    }
    
    return showSingleMessage("*ERROR", message, sticky);
}

export function showWarnMessage(message, sticky){
    return showSingleMessage("*WARN", message, sticky);
}

export function showInfoMessage(message, sticky){
    return showSingleMessage("*INFO", message, sticky);
}

export function showSingleMessage(type, message, sticky){
    
    initialiseMessaging();
    
    if (typeof sticky === "undefined" || sticky === null){
        sticky = false;
    }
    
    if (type === "*ERROR"){
        $.jGrowl(message, {header: Translator.tr("Error"), sticky: sticky, theme: "jError"});
    } else if (type === "*WARN"){
        $.jGrowl(message, {header: Translator.tr("Warning"), sticky: sticky, theme: "jWarn"});
    } else {
        $.jGrowl(message, {header: Translator.tr("Information"), sticky: sticky, theme: "jInfo"});
    }
}

export function displayMessages(errorMessages, warningMessages, infoMessages) {

    initialiseMessaging();
    
    if (typeof errorMessages !== "undefined" && errorMessages.length > 0) {

        for (var i = 0; i < errorMessages.length; i++) {
            $.jGrowl(errorMessages[i], {header: Translator.tr("Error"), sticky: true, theme: "jError"});
        }

    }

    if (typeof warningMessages !== "undefined" && warningMessages.length > 0) {

        for (var i = 0; i < warningMessages.length; i++) {
            $.jGrowl(warningMessages[i], {header: Translator.tr("Warning"), sticky: false, theme: "jWarn"});
        }

    }

    if (typeof infoMessages !== "undefined" && infoMessages.length > 0) {
        
        for (var i = 0; i < infoMessages.length; i++) {
            $.jGrowl(infoMessages[i], {header: Translator.tr("Information"), sticky: false, theme: "jInfo"});
        }

    }
    
}

export function destroyMessages() {
    $("div.jGrowl-notification").trigger('jGrowl.close');    
}


export function displayFieldHighlights(errorFieldHighlights, warningFieldHighlights, infoFieldHighlights, $context = null) {
    
    destroyFieldHighlights();
    
    if ( $context == null ){
        $context = $( "body" );
    }
    
    if (typeof errorFieldHighlights !== "undefined" && errorFieldHighlights.length > 0) {

        for (var i = 0; i < errorFieldHighlights.length; i++) {
            $("label[for='" + errorFieldHighlights[i] + "']", $context ).addClass("formError error");
            $(".iconInput." + errorFieldHighlights[i], $context).addClass("formError error");
        }

    }

    if (typeof warningFieldHighlights !== "undefined" && warningFieldHighlights.length > 0) {

        for (var i = 0; i < warningFieldHighlights.length; i++) {
            $("label[for='" + warningFieldHighlights[i] + "']").addClass("formWarning warning");
        }

    }

    if (typeof infoFieldHighlights !== "undefined" && infoFieldHighlights.length > 0) {
        
        for (var i = 0; i < infoFieldHighlights.length; i++) {
            $("label[for='" + infoFieldHighlights[i] + "']").addClass("formInfo info");
        }

    }
    
}

export function destroyFieldHighlights() {
    $("label").removeClass("formError formWarning formInfo error warning info");
    $(".iconInput").removeClass("formError formWarning formInfo error warning info");
}
